import StoryDescription from "./StoryDescription"

export default function Story({ title, tags, description, project, company, skills }) {
    const activeTags = tags.reduce(
        (obj, tag) => {
            if (skills[tag] && skills[tag].display !== false) {
                obj.push(tag)
            }

            return obj
        }, []
    )

    const inactiveTags = tags.reduce(
            (obj, tag) => {
                if (!skills[tag] || skills[tag].display === false) {
                    obj.push(tag)
                }

                return obj
            }, []
        )


    return (
        <div className="story">
            <h4 className="title"> { title } </h4>
            <div className="tags">
                {
                    company.tag ?
                        <div className="tags-company">
                            <i className="tag tag-company">{ company.name }</i>
                            {
                                project && project.tag ?
                                    <>
                                        <span className="separator">-</span>
                                        <i className="tag tag-project">{ project.name }</i>
                                    </>
                                : <></>
                            }
                        </div>
                    : <></>
                }
                {
                    tags ?
                        <div className="tags-tool">
                            {
                                activeTags.map((tag, i) => {
                                        let classes = ["tag"]

                                        if (!skills[tag].enabled) {
                                            classes.push("disabled")
                                        }

                                        return (<i 
                                            key={tag} 
                                            className={ classes.join(" ") }
                                        >
                                                { tag }
                                        </i>)
                                    }
                                )
                            }
                            {
                                inactiveTags.map((tag, i) => {
                                    return (<i 
                                        key={tag} 
                                        className="tag inactive"
                                    >
                                            { tag }
                                    </i>)
                                })
                            }
                        </div>
                    : <></>
                }
            </div>
            <StoryDescription descriptions={description} tags={tags} />
        </div>
    )
}